/**
 * Created by zhaohaixi on 2018/9/12.
 */
import TYPES from '../types.js'
import Cookie from 'js-cookie'

export const lenovoDataInitState = {
  // 全局变量，不可修改
  userInfo: {
    entRole: [], // 企业版用户角色
  },
  accountInfo: {},
  boxUserInfo: {},
  S: Cookie.get('S') || '',
  session: {}, // session
  language: 'zh', // 语言
  session_id: '',
  customize: {
    // 自定义设置,水印等相关
    customService: 0,
    helpDocument: 0,
    helpDocumentUrl: '',
    helpGuide: 0,
    switchLanguage: true,
    disableDownloadClient: true,
  },
  boxType: '',
  specialVersion: '',
}

export const LenovoDataGetters = {
  S: state => state.lenovoData.S,
  accountId: state => state.lenovoData.userInfo.account_id,
  uId: state => state.lenovoData.userInfo.uid,
  userInfo: state => state.lenovoData.userInfo,
  boxUserInfo: state => state.lenovoData.boxUserInfo,
  boxLoginUrl: state => state.lenovoData.boxUserInfo.box_login_url,
  accountInfo: state => state.lenovoData.accountInfo,
  accountConfig: state => state.lenovoData.customize,
  session: state => state.lenovoData.session,
  session_id: state => state.lenovoData.session_id,
  entRole: state => state.lenovoData.userInfo.entRole,
  language: state => state.lenovoData.language,
  boxType: state => state.lenovoData.boxType,
  specialVersion: state => state.lenovoData.specialVersion,
}

export const lenovoDataMutations = {
  [TYPES.GET_LENOVO_LANGUAGE](state, data) {
    state.lenovoData.language = data
  },
  [TYPES.GET_USER_INFO](state, data) {
    state.lenovoData.userInfo = { ...state.lenovoData.userInfo, ...data }
  },
  [TYPES.GET_BOX_USER_INFO](state, data) {
    state.lenovoData.boxUserInfo = { ...state.lenovoData.boxUserInfo, ...data }
  },
  [TYPES.GET_LENOVO_ACCOUNT_INFO](state, data) {
    state.lenovoData.accountInfo = data
  },
  [TYPES.GET_LENOVO_CUSTOMIZE_INFO](state, data) {
    state.lenovoData.customize = { ...state.lenovoData.customize, ...data }
  },
  [TYPES.GET_SESSION](state, data) {
    state.lenovoData.session = data
  },
  [TYPES.GET_SESSION_ID](state, data) {
    state.lenovoData.session_id = data
  },
  [TYPES.GET_USER_ROLE](state, data) {
    state.lenovoData.userInfo.entRole = data.map(item => item.key)
  },
  [TYPES.GET_BOX_Type](state, data) {
    state.lenovoData.boxType = data
    state.isHideLogin = data !== 'private'
  },
  [TYPES.GET_SPECIAL_VERSION](state, data) {
    state.lenovoData.specialVersion = data
  },
  setSessionId(state) {
    state.lenovoData.S = Cookie.get('S')
  },
  clearSessionId(state) {
    state.lenovoData.S = null
  },
}



// WEBPACK FOOTER //
// ./store/modules/m-get-lenovodata.js